var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    enableBackground: "new 0 0 400 400",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCE9FF",
    d: "M287.04,206.56v101.68c0,5.37-1.771,10.34-4.76,14.34c-4.38,5.86-11.36,9.65-19.23,9.65H57.66 c-7.88,0-14.87-3.79-19.24-9.65c-0.32-0.43-0.63-0.87-0.92-1.33c-2.43-3.75-3.84-8.22-3.84-13.01V102.849 c0-13.26,10.74-23.989,24-23.989h205.39c8.86,0,16.601,4.8,20.75,11.95l-33.02,33.029l-73.08,73.09l-53.23-53.229 c-9.4-9.4-28.19-9.4-37.57,0l-21.92,21.91c-3.33,3.33-5.48,7.84-6.44,12.689c-1.78,8.83,0.37,18.82,6.44,24.891l93.93,93.93 c9.39,9.39,28.17,9.39,37.57,0l21.92-21.92L287.04,206.56z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A94F4",
    d: "M359.29,134.299l-72.25,72.261l-68.64,68.64l-21.92,21.92c-9.4,9.39-28.18,9.39-37.57,0l-93.93-93.93 c-6.07-6.07-8.22-16.061-6.44-24.891c0.96-4.85,3.11-9.359,6.44-12.689l21.92-21.91c9.38-9.4,28.17-9.4,37.57,0l53.23,53.229 l73.08-73.09L283.8,90.81l16-15.99c9.4-9.4,28.19-9.4,37.57,0l21.92,21.91c2.56,2.569,4.43,5.83,5.59,9.409 C367.99,115.679,366.12,127.469,359.29,134.299z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.00ea37c8cace31bb86cc8731917126af.svg";
export { ForwardRef as ReactComponent };